import React from 'react';
import 'src/styles/main.scss';
import Tutor from './views/Tutor/Tutor';
import { RecoilRoot } from 'recoil';

function MainApplication() {
  return (
    <div className='h-screen'>
      <RecoilRoot>
        <Tutor />
      </RecoilRoot>
    </div>
  );
}

export default MainApplication;
